import _Vue, { VNode } from "vue";
import FacebookPixel, { FaceBookPixelEvents, IFacebookPurchase, IFacebookPurchaseItem, IFacebookViewContent } from "./FacebookPixel";

//Vue install extend
export function VueFacebookPixel<VueFacebookPluginOptions>(Vue: typeof _Vue, options?: VueFacebookPluginOptions): void {
    // do stuff with options
    Vue.prototype.facebookpixel = FacebookPixel;

    Vue.directive("fbqTrack", {
        //as you see it! - if component is lazy loaded
        //and ensure facebook pixel is loaded at the moment
        inserted: (elm: any, binding: any, vNode: VNode) =>{
            let modifiers : { [key: string]: boolean } = binding.modifiers;

            if(modifiers["product"]){
                const trackingObj = convertProductToTrackingObject(binding.value, 'product');
                FacebookPixel.event(FaceBookPixelEvents.page.viewcontent, trackingObj)
            }
            if(modifiers["addtocart"]){
                const trackingObj = convertProductToTrackingObject(binding.value, 'product');
                
                const buybtn = <HTMLElement>elm.querySelector('.json-buy-btn').querySelector('.btn');
                const quantity = <HTMLInputElement>elm.querySelector('[name="quantity"]');
                
                buybtn.addEventListener('click', (event: Event) => {
                    if(!!quantity){
                        //add value
                        trackingObj.quantity = quantity.value;
                    }
                    FacebookPixel.event(FaceBookPixelEvents.order.addToCart,trackingObj);
                });
            }

            if(modifiers["purchase"]){
                const trackingObj = convertProductToTrackingObject(binding.value, 'purchase');
                FacebookPixel.event(FaceBookPixelEvents.order.purchase,trackingObj);
            }
        },
        // unbind: (elm: any) => unbindElement(elm),
        // componentUpdated: (elm: any, binding: any, vNode: VNode) =>{bindElement(elm, binding, vNode)},
        // update: (elm: any, binding: any, vNode: VNode) =>{bindElement(elm, binding, vNode)},
    });
}

function convertProductToTrackingObject(obj: any, type: string) : any {
    
    switch(type){
        case 'product' || 'addtocart': {
            return <IFacebookViewContent>{
                content_name: obj.name,
                content_ids: obj.Number,
                content_type: 'product',
                quantity: 1,
            }    
        }
        case 'purchase': {
            var contents = obj.contents.map((x: any) => <IFacebookPurchaseItem>{
                id : x.id,
                quantity: x.quantity
            });
            
            return <IFacebookPurchase>{
                value : obj.value,
                currency : obj.currency,
                content_type: 'product',
                contents: contents,
                //content_ids: contents.map((x: IFacebookPurchaseItem) => x.id)
            };
        }
        
        default:
        throw new Error('Unknown type, facebook pixel tracking object could not be resolved');
    }
    
    
}



interface VueFacebookPluginOptions{
    //test
}
